import { Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Controller, useForm, useFormContext, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { addressTypeArray, countryList, employmentDataArray, genderOption, maritalStatusArray, provinceList, radioColorSx, radioOptionArray, titleArray } from 'store/constant';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router';
import { useFullPageLoader } from 'hooks/useFullPageLoader';

const PersonalInformation = ({ personRef, activeStep, setActiveStep }) => {
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id')
    const userId = id ? id : userGetId;
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const { register, control, watch, handleSubmit, trigger, setValue, getValues, formState: { errors } } = useFormContext();

    const checkShrink = (fieldName) => {
        const val = watch(fieldName);
        return val != null && val !== "" ? true : undefined;
    };

    const pEmploymentStatus = useWatch({ control, name: 'p_employment_status' });
    const sFirstName = useWatch({ control, name: 's_first_name' });
    // const registrationType = useWatch({ control, name: 'registration_type' });
    const sEmploymentStatus = useWatch({ control, name: 's_employment_status' });
    const pMaritalStatus = useWatch({ control, name: 'p_marital_status' });
    const jointMaritalStatus = useWatch({ control, name: 'jt_marital_status' });
    const pRegistrationType = useWatch({ control, name: 'registration_type' });
    // const spouseName = useWatch({ control, name: 's_first_name' });

    React.useImperativeHandle(personRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));



    const handleRoleBack = async () => {
        // setActiveStep(activeStep - 1);
        let endPoint = `api/change-form-step`;
        showLoader();
        const submitData = { user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveStep(activeStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        } finally {
            hideLoader();
        }
    };

    const submitPersonalInfo = async (data) => {
        let endPoint = `api/save-user-personal-info`;

        const submitData = { ...data, user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep + 1 }

        showLoader();
        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveStep(activeStep + 1);
            }

        } catch (error) {
            // console.error(error)
        } finally {
            hideLoader();
        }
    }


    return (
        <>
            <form onSubmit={handleSubmit(submitPersonalInfo)} className='mt-3 p-4'>
                <Grid container spacing={2}>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-title-label" className='font15px'>Title</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.p_title)}>
                            <InputLabel id="p-title-label">Title</InputLabel>

                            <Controller
                                name="p_title"
                                control={control}
                                rules={{ required: 'Title is required' }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? ''}
                                        labelId="p-title-label"
                                        id="p-title"
                                        label="Title"
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } },
                                        }}
                                    >
                                        {titleArray.map((row) => (
                                            <MenuItem key={row.value} value={row.value}>
                                                {row.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={6}></Grid>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label className='font15px'>First Name</label>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_first_name') }}
                            label="First Name"
                            id='p_first_name'
                            fullWidth
                            size='small'
                            {...register('p_first_name', { required: true })}
                            error={Boolean(errors && errors['p_first_name'])}
                        />

                    </Grid>
                    <Grid item xs={3}></Grid>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-middle-initial" className='font15px'>Middle Initial</label>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_middle_name') }}
                            label="Middle Initial"
                            id='p-middle-initial'
                            fullWidth
                            size='small'
                            {...register('p_middle_name', {
                                // onChange: changePersonalInfo,
                                // required: true
                            })}
                        // error={Boolean(errors && errors['p_middle_name'])}
                        />
                    </Grid>
                    <Grid item xs={3}></Grid>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-last-name" className='font15px'>Last Name</label>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_last_name') }}
                            label="Last Name"
                            fullWidth
                            id='p-last-name'
                            size='small'
                            {...register('p_last_name', {
                                // onChange: changePersonalInfo,
                                required: true
                            })}
                            error={Boolean(errors && errors['p_last_name'])}
                        />
                    </Grid>
                    <Grid item xs={3}></Grid>


                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-email" className='font15px'>Email</label>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_email') }}
                            label="Email"
                            fullWidth
                            id='p-email'
                            size='small'
                            // {...register("p_email", { required: true })}
                            {...register("p_email", {
                                required: "Email is required",
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            })}
                            error={Boolean(errors?.p_email)}
                        />
                    </Grid>
                    <Grid item xs={3}></Grid>

                    <Grid item xs={12} sm={3} md={3} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                        <label htmlFor="is-tex-resident-canada" className='font15px'>Social Insurance Number</label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_sin') }}
                            label="Social Insurance Number"
                            fullWidth
                            id='p_sin'
                            size='small'
                            {...register("p_sin", { required: true })}
                            error={Boolean(errors?.p_sin)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}></Grid>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-dob" className='font15px'>Date Of Birth</label>
                    </Grid>

                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                                <Controller
                                    name="p_dob"
                                    control={control}
                                    render={({ field }) => (
                                        <DesktopDatePicker
                                            disableFuture
                                            label="Date of Birth"
                                            inputFormat="yyyy/MM/dd"
                                            value={field.value || null} // Use `null` instead of empty string for DatePicker
                                            onChange={field.onChange} // Directly use field.onChange
                                            renderInput={(params) => (
                                                <TextField InputLabelProps={{ shrink: checkShrink('p_no_of_dependent') }}
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}></Grid>


                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-marital-status" className='font15px'>Marital Status</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.p_marital_status)}>
                            <InputLabel id="p-marital-status-label">Marital Status</InputLabel>
                            <Controller
                                name="p_marital_status"
                                control={control}
                                rules={{ required: "Marital Status is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? ''}

                                        labelId="p-marital-status-label"
                                        id="p-marital-status"
                                        label="Marital Status"
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                    >
                                        <MenuItem value={0}>Select Status</MenuItem>

                                        {maritalStatusArray.map((row) => (
                                            <MenuItem key={row.value} value={row.value}>
                                                {row.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>



                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-no-of-dependent" className='font15px'>No of Dependents</label>
                    </Grid>

                    <Grid item xs={6}>

                        <TextField
                            label="No of Dependents"
                            fullWidth
                            id='p_no_of_dependent'
                            size='small'
                            {...register("p_no_of_dependent", { required: true })}
                            error={Boolean(errors?.p_no_of_dependent)}
                        />
                    </Grid>
                    <Grid item xs={3}></Grid>




                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-citizenship" className='font15px'>Country</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.p_citizenship)}>
                            <InputLabel id="p-citizenship-label">Country</InputLabel>
                            <Controller
                                name="p_citizenship"
                                control={control}
                                rules={{ required: "Country is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? ''}
                                        labelId="p-citizenship-label"
                                        id="p-citizenship"
                                        label="Country"
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                    >
                                        {countryList?.map((row) => (
                                            <MenuItem key={row.value} value={row.value}>
                                                {row.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}></Grid>

                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-gender" className='font15px'>Gender</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl component="fieldset" error={Boolean(errors?.p_gender)}>
                            <Controller
                                name="p_gender"
                                control={control}
                                rules={{ required: "Gender is required" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        {...field}
                                        row
                                        aria-labelledby="p_gender"
                                    >
                                        {genderOption.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />

                            {errors?.p_gender && (
                                <Typography variant="caption" color="error">
                                    {errors.p_gender.message}
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>

                    {/* ------------- PERSON PHONE NUMBER -------------- */}

                    <Grid item xs={3} className=' text-right align-content-center'>
                        <label className='font15px'>Please provide at least one phone number</label>
                    </Grid>

                    <Grid item xs={3}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_home_phone') }}
                            label="Home Phone"
                            fullWidth
                            id='p_home_phone'
                            size='small'
                            {...register("p_home_phone")}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_cell_phone') }}
                            label="Cell Phone"
                            fullWidth
                            id='p_cell_phone'
                            size='small'
                            {...register("p_cell_phone", { required: true })}
                            error={Boolean(errors?.p_cell_phone)}
                        />
                    </Grid>

                    <Grid item xs={3}></Grid>

                    <Grid item xs={3}></Grid>
                    <Grid item xs={3}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_business_phone') }}
                            label="Business Phone"
                            fullWidth
                            id='p_business_phone'
                            size='small'
                            {...register("p_business_phone")}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField InputLabelProps={{ shrink: checkShrink('p_extension') }}
                            label="Extension"
                            fullWidth
                            id='p_extension'
                            size='small'
                            {...register("p_extension")}
                        />
                    </Grid>
                    <Grid item xs={3}></Grid>

                    {/* ------------- EO PERSON PHONE NUMBER -------------- */}


                    <Grid item xs={3} className='text-right align-content-center'>
                        <label htmlFor="p-employment-status" className='font15px'>Employment Status</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.p_employment_status)}>
                            <InputLabel id="p-employment-status-label">Employment Status</InputLabel>
                            <Controller
                                name="p_employment_status"
                                control={control}
                                rules={{ required: "Employment Status is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? ''}
                                        labelId="p-employment-status-label"
                                        id="p-employment-status"
                                        label="Employment Status"
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                    >
                                        <MenuItem value={0}>Select Employment Status</MenuItem>

                                        {employmentDataArray.map((row) => (
                                            <MenuItem key={row.value} value={row.value}>
                                                {row.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>

                    {pEmploymentStatus === 1 || pEmploymentStatus === 2 || pEmploymentStatus === 3 ?
                        <>
                            <Grid item xs={3} className=' text-right align-content-center'>
                                <label className='font15px'>Professional / Job Title</label>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('p_emp_job_title') }}
                                    label="Job Title"
                                    fullWidth
                                    id='p_emp_job_title'
                                    size='small'
                                    {...register("p_emp_job_title", { required: true })}
                                    error={Boolean(errors?.p_emp_job_title)}

                                />
                            </Grid>
                            <Grid item xs={3}></Grid>

                            <Grid item xs={3} className='text-right align-content-center'>
                                <label htmlFor="p-emp-name" className='font15px'>Name Of Employer</label>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('p_emp_name') }}
                                    label="Name Of Employer"
                                    fullWidth
                                    id='p-emp-name'
                                    size='small'
                                    {...register("p_emp_name", { required: true })}
                                    error={Boolean(errors?.p_emp_name)}
                                />
                            </Grid>
                            <Grid item xs={3}></Grid>


                            <Grid item xs={3} className='text-right align-content-center'>
                                <label htmlFor="p-emp-business" className='font15px'>Type of Business</label>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('p_emp_business') }}
                                    label="Type of Business"
                                    fullWidth
                                    id='p-emp-business'
                                    size='small'
                                    {...register("p_emp_business", { required: true })}
                                    error={Boolean(errors?.p_emp_business)}
                                />
                            </Grid>
                            <Grid item xs={3}></Grid>

                            {/* date of retirement */}
                            {pEmploymentStatus == 3 &&
                                <>
                                    <Grid item xs={3} className='text-right align-content-center'>
                                        <label htmlFor="spousal_retirement_date" className='font15px'>Date of Retirement</label>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <Stack spacing={3}>
                                                <Controller
                                                    name="p_emp_retirement_date"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <DesktopDatePicker
                                                            disableFuture
                                                            label="Date Of Retirement"
                                                            inputFormat="yyyy/MM/dd"
                                                            value={field.value || null}
                                                            onChange={(newValue) => field.onChange(newValue)}
                                                            renderInput={(params) => (
                                                                <TextField InputLabelProps={{ shrink: checkShrink('p_emp_years_employment') }}
                                                                    {...params}
                                                                    fullWidth
                                                                    size="small"
                                                                    error={Boolean(errors?.p_emp_retirement_date)}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={5}></Grid>
                                </>
                            }

                            <Grid item xs={3} className='text-right align-content-center'>
                                <label htmlFor="p-emp-year" className='font15px'>Years of Employment</label>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Years of Employment"
                                    fullWidth
                                    id='p-emp-year'
                                    size='small'
                                    {...register("p_emp_years_employment", { required: true })}
                                    error={Boolean(errors?.p_emp_years_employment)}
                                />
                            </Grid>
                            <Grid item xs={3}></Grid>
                        </>
                        : ''}
                </Grid>

                {/* ================================== Spousal Information ========================================== */}

                {pMaritalStatus === 2 || pMaritalStatus === 3 ?

                    <Grid container spacing={2} className='mt-3'>
                        <Grid item xs={12}>
                            <Typography component={'h2'} className='form-head-gray-title'>Spousal Information</Typography>
                        </Grid>
                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="spousal_first_name" className='font15px'>First Name</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_first_name') }}
                                label="First Name"
                                fullWidth
                                size='small'
                                {...register("s_first_name", { required: true })}
                                error={Boolean(errors?.s_first_name)}
                            />

                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-middle-initial" className='font15px'>Middle Initial</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_middle_name') }}
                                label="Middle Initial"
                                id='s-middle-initial'
                                fullWidth
                                size='small'
                                {...register("s_middle_name")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-last-name" className='font15px'>Last Name</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_last_name') }}
                                label="Last Name"
                                fullWidth
                                id='s-last-name'
                                size='small'
                                {...register("s_last_name", { required: true })}
                                error={Boolean(errors?.s_last_name)}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-gender" className='font15px'>Gender</label>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl component="fieldset" error={Boolean(errors?.s_gender)}>
                                <Controller
                                    name="s_gender"
                                    control={control}
                                    rules={{ required: "Gender is required" }}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row aria-labelledby="sGender">
                                            {genderOption.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-marital-status" className='font15px'>Marital Status</label>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="s_marital_status"
                                control={control}
                                render={({ field }) => (
                                    <TextField InputLabelProps={{ shrink: checkShrink('s_email') }}
                                        sx={{ mt: "8px" }}
                                        {...field}
                                        select
                                        fullWidth
                                        size="small"
                                        label="Marital Status"
                                        value={pMaritalStatus === 2 ? 2 : 3}
                                        disabled={pMaritalStatus === 2 || pMaritalStatus === 3}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        error={Boolean(errors?.s_marital_status)}
                                    >
                                        {maritalStatusArray.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="a-email" className='font15px'>Email</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                label="Email"
                                fullWidth
                                id='s-email'
                                size='small'
                                {...register("s_email", {
                                    required: true,
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Enter a valid email address",
                                    },
                                })}
                                error={Boolean(errors?.s_email)}

                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-dob" className='font15px'>Date Of Birth</label>
                        </Grid>

                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <Controller
                                        name="s_dob"
                                        control={control}
                                        render={({ field }) => (
                                            <DesktopDatePicker
                                                disableFuture
                                                label="Date Of Birth"
                                                inputFormat="yyyy/MM/dd"
                                                value={field.value || null}  // Use `null` instead of empty string for DatePicker
                                                onChange={(newValue) => field.onChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField InputLabelProps={{ shrink: checkShrink('s_sin') }}
                                                        {...params}
                                                        fullWidth
                                                        size="small"
                                                        error={Boolean(errors?.s_dob)}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={12} sm={3} md={3} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="is-tex-resident-canada" className='font15px'>Social Insurance Number</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                label="Social Insurance Number"
                                fullWidth
                                id='s_sin'
                                size='small'
                                {...register("s_sin", { required: true })}
                                error={Boolean(errors?.s_sin)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-citizenship" className='font15px'>Country</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.s_citizenship)}>
                                <InputLabel id="s-citizenship-label">Country</InputLabel>
                                <Controller
                                    name="s_citizenship"
                                    control={control}
                                    rules={{ required: "Citizenship is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value ?? ''}
                                            labelId="s-citizenship-label"
                                            id="s-citizenship"
                                            label="Country"
                                            classes={{ select: "custom-select-label" }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}
                                        >

                                            <MenuItem value="canada">Canada</MenuItem>
                                            {/* <MenuItem value="oth">Other</MenuItem> */}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid>



                        {/* ------------- SPOUSAL PHONE NUMBER -------------- */}

                        <Grid item xs={3} className=' text-right align-content-center'>
                            <label className='font15px'>Please provide at least one phone number</label>
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_home_phone') }}
                                label="Home Phone"
                                fullWidth
                                id='s_home_phone'
                                size='small'
                                {...register("s_home_phone")}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_cell_phone') }}
                                label="Cell Phone"
                                fullWidth
                                id='s_cell_phone'
                                size='small'
                                {...register("s_cell_phone", { required: true })}
                                error={Boolean(errors?.s_cell_phone)}

                            />
                        </Grid>

                        <Grid item xs={3}></Grid>

                        <Grid item xs={3}></Grid>
                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_business_phone') }}
                                label="Business Phone"
                                fullWidth
                                id='s_business_phone'
                                size='small'
                                {...register("s_business_phone")}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('s_extension') }}
                                label="Extension"
                                fullWidth
                                id='s_extension'
                                size='small'
                                {...register("s_extension")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>


                        {/* ------------- EO SPOUSAL PHONE NUMBER -------------- */}

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-co-by-email-radio-group" className='font15px'>Will {sFirstName}  also be opening accounts and investing?</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl>
                                <Controller
                                    name="s_investing_account"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup
                                            row
                                            id="s-investing-account"
                                            {...field} // Spreads `value` and `onChange` automatically
                                        >
                                            {radioOptionArray.map((row) => (
                                                <FormControlLabel
                                                    key={row.value}
                                                    value={row.value}
                                                    control={<Radio sx={radioColorSx} />}
                                                    label={row.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="s-employment-status" className='font15px'>Employment Status</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.s_employment_status)}>
                                <InputLabel id="s-employment-status-label">Employment Status</InputLabel>
                                <Controller
                                    name="s_employment_status"
                                    control={control}
                                    rules={{ required: "Employment status is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value ?? ''}
                                            labelId="s-employment-status-label"
                                            id="s-employment-status"
                                            label="Employment Status"
                                            classes={{ select: "custom-select-label" }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}
                                        >
                                            <MenuItem value={0}>Select Employment Status</MenuItem>

                                            {employmentDataArray.map((row) => (
                                                <MenuItem key={row.value} value={row.value}>
                                                    {row.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid>


                        {sEmploymentStatus === 1 || sEmploymentStatus === 2 || sEmploymentStatus === 3 ?

                            <>
                                <Grid item xs={3} className=' text-right align-content-center'>
                                    <label className='font15px'>Professional / Job Title</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('s_emp_job_title') }}
                                        label="Job Title"
                                        fullWidth
                                        id='s_emp_job_title'
                                        size='small'
                                        {...register("s_emp_job_title", { required: true })}

                                        error={Boolean(errors?.s_emp_job_title)}

                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="s-emp-name" className='font15px'>Name Of Employer</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('s_emp_name') }}
                                        label="Name Of Employer"
                                        fullWidth
                                        id='s-emp-name'
                                        size='small'
                                        {...register("s_emp_name", { required: true })}
                                        error={Boolean(errors?.s_emp_name)}

                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>


                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="s-emp-business" className='font15px'>Type of Business</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('s_emp_business') }}
                                        label="Type of Business"
                                        fullWidth
                                        id='s-emp-business'
                                        size='small'
                                        {...register("s_emp_business", { required: true })}
                                        error={Boolean(errors?.s_emp_business)}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                {/* date of retirement */}
                                {sEmploymentStatus == 3 &&
                                    <>
                                        <Grid item xs={3} className='text-right align-content-center'>
                                            <label htmlFor="spousal_retirement_date" className='font15px'>Date of Retirement</label>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <Stack spacing={3}>
                                                    <Controller
                                                        name="s_emp_retirement_date"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <DesktopDatePicker
                                                                disableFuture
                                                                label="Date Of Retirement"
                                                                inputFormat="yyyy/MM/dd"
                                                                value={field.value || null} // Ensure null value handling
                                                                onChange={field.onChange} // No need for custom handleChangeDate function
                                                                renderInput={(params) => (
                                                                    <TextField InputLabelProps={{ shrink: checkShrink('s_emp_years_employment') }}
                                                                        {...params}
                                                                        fullWidth
                                                                        size="small"
                                                                        error={Boolean(errors?.s_emp_retirement_date)}
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={5}></Grid>
                                    </>
                                }

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="s-emp-year" className='font15px'>Years of Employment</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Years of Employment"
                                        fullWidth
                                        id='s-emp-year'
                                        size='small'
                                        {...register("s_emp_years_employment", { required: true })}
                                        error={Boolean(errors?.s_emp_years_employment)}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>
                            </>
                            : null
                        }
                    </Grid>
                    :
                    null
                }


                {/* ================================ JOINT ACCOUNT ========================================= */}
                {(pRegistrationType == 2 || pRegistrationType == 4) ?
                    <Grid container spacing={2} className='mt-3'>

                        <Grid item xs={12}>
                            <Typography component="h2" className="form-head-gray-title">Joint Account</Typography>
                        </Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-title-label" className='font15px'>Title</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.jt_title)}>
                                <InputLabel id="jt-title-label">Title</InputLabel>
                                <Controller
                                    name="jt_title"
                                    control={control}
                                    rules={{ required: "Title is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value ?? ''}
                                            labelId="jt-title-label"
                                            id="jt-title"
                                            label="Title"
                                            classes={{ select: "custom-select-label" }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}
                                        >

                                            {/* <MenuItem value={0}>Select Title</MenuItem> */}

                                            {titleArray.map((row) => (
                                                <MenuItem key={row.value} value={row.value}>
                                                    {row.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-marital-status" className='font15px'>Marital Status</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.jt_marital_status)}>
                                <InputLabel id="jt-marital-status-label">Marital Status</InputLabel>
                                <Controller
                                    name="jt_marital_status"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value || ''}
                                            labelId="jt-marital-status-label"
                                            id="jt-marital-status"
                                            label="Marital Status"
                                            onChange={field.onChange} // No need for custom handleChangeData
                                            classes={{ select: "custom-select-label" }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}
                                        >
                                            {maritalStatusArray.map((row) => (
                                                <MenuItem key={row.value} value={row.value}>{row.label}</MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt_first_name" className='font15px'>First Name</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_first_name') }}
                                label="First Name"
                                fullWidth
                                size='small'
                                {...register("jt_first_name", { required: true })}
                                error={Boolean(errors?.jt_first_name)}
                            />

                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-middle-initial" className='font15px'>Middle Initial</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_middle_name') }}
                                label="Middle Initial"
                                id='jt-middle-initial'
                                fullWidth
                                size='small'
                                {...register("jt_middle_name")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-last-name" className='font15px'>Last Name</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_last_name') }}
                                label="Last Name"
                                fullWidth
                                id='jt-last-name'
                                size='small'
                                {...register("jt_last_name", { required: true })}
                                error={Boolean(errors?.jt_last_name)}

                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        {/* ----------sin---------- */}
                        <Grid item xs={12} sm={3} md={3} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="is-tex-resident-canada" className='font15px'>Social Insurance Number</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_sin') }}
                                label="Social Insurance Number"
                                fullWidth
                                size="small"
                                margin="dense"
                                name='jt_sin'
                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                {...register("jt_sin", { required: true })}
                                error={Boolean(errors?.jt_sin)}

                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={3}></Grid>


                        {/* ----------dob -------- */}
                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-dob" className='font15px'>Date Of Birth</label>
                        </Grid>

                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <Controller
                                        name="jt_dob"
                                        control={control}
                                        render={({ field }) => (
                                            <DesktopDatePicker
                                                disableFuture
                                                label="Date Of Birth"
                                                inputFormat="yyyy/MM/dd"
                                                value={field.value || null}
                                                onChange={(newValue) => field.onChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_email') }}
                                                        {...params}
                                                        fullWidth
                                                        size="small"
                                                        error={Boolean(errors?.jt_dob)}
                                                        helperText={errors?.jt_dob?.message}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}></Grid>

                        {/* ----------email -------- */}
                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-email" className='font15px'>Email</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                label="Email"
                                fullWidth
                                id='jt-email'
                                size='small'
                                // {...register("jt_email")}
                                {...register("jt_email", {
                                    required: true,
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Enter a valid email address",
                                    },
                                })}
                                error={Boolean(errors?.jt_email)}

                            />
                        </Grid>
                        <Grid item xs={3}></Grid>



                        {/* ------------- PERSON PHONE NUMBER -------------- */}

                        <Grid item xs={3} className=' text-right align-content-center'>
                            <label className='font15px'>Please provide at least one phone number</label>
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_home_phone') }}
                                label="Home Phone"
                                fullWidth
                                id='jt_home_phone'
                                size='small'
                                {...register("jt_home_phone")}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_cell_phone') }}
                                label="Cell Phone"
                                fullWidth
                                id='jt_cell_phone'
                                size='small'
                                {...register("jt_cell_phone")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3}></Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_business_phone') }}
                                label="Business Phone"
                                fullWidth
                                id='jt_business_phone'
                                size='small'
                                {...register("jt_business_phone")}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_extension') }}
                                label="Extension"
                                fullWidth
                                id='jt_extension'
                                size='small'
                                {...register("jt_extension")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>
                        {/* ------------- EO PERSON PHONE NUMBER -------------- */}


                        {/* ----------nod -------- */}

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-no-of-dependent" className='font15px'>No of Dependents</label>
                        </Grid>

                        <Grid item xs={6}>

                            <TextField InputLabelProps={{ shrink: checkShrink('jt_no_of_dependent') }}
                                label="No of Dependents"
                                fullWidth
                                id='jt_no_of_dependent'
                                size='small'
                                {...register("jt_no_of_dependent")}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-citizenship" className='font15px'>Country</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.jt_citizenship)}>
                                <InputLabel id="jt-citizenship-label">Country</InputLabel>
                                <Controller
                                    name="jt_citizenship"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value ?? ''}
                                            labelId="jt-citizenship-label"
                                            id="jt-citizenship"
                                            label="Country"
                                            classes={{ select: "custom-select-label" }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}
                                        >
                                            {countryList?.map((row) => (
                                                <MenuItem key={row.value} value={row.value}>
                                                    {row.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}></Grid>

                        {/* ----------------------------ADDRESS --------------------------- */}

                        <Grid item xs={12} sm={12} md={12} container spacing={2}>
                            <Grid item xs={3} className='text-right align-content-center'>
                                <label htmlFor="jt-address-type" className='font15px'>Address Type</label>
                            </Grid>

                            <Grid item xs={3}>
                                <FormControl sx={{ minWidth: 280 }} size="small">
                                    <InputLabel id="jt-address-type">Address Type</InputLabel>
                                    <Controller
                                        name="jt_address_type"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="jt-address-type"
                                                id="jt-address-type"
                                                label="Address Type"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                {addressTypeArray?.map((row) => (
                                                    <MenuItem key={row.value} value={row.value}>
                                                        {row.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}></Grid>

                            <Grid item xs={12}>
                                <Typography component={'h3'} className='form-head-gray-title' sx={{
                                    backgroundColor: "transparent",
                                    fontWeight: 600
                                }}>Address</Typography>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_rr_no') }}
                                    label="RR No"
                                    fullWidth
                                    size="small"
                                    {...register("jt_rr_no", { required: true })}
                                    error={Boolean(errors?.jt_rr_no)}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_street_no') }}
                                    label="Street No"
                                    fullWidth
                                    size="small"
                                    {...register("jt_street_no", { required: true })}
                                    error={Boolean(errors?.jt_street_no)}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_street_name') }}
                                    label="Street Name"
                                    fullWidth
                                    size="small"
                                    {...register("jt_street_name", { required: true })}
                                    error={Boolean(errors?.jt_street_name)}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_street_type') }}
                                    label="Street Type"
                                    fullWidth
                                    size="small"
                                    {...register("jt_street_type", { required: true })}
                                    error={Boolean(errors?.jt_street_type)}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_unit_no') }}
                                    label="Unit/Apt No"
                                    fullWidth
                                    size="small"
                                    {...register("jt_unit_no")}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_unit_type') }}
                                    label="Unit Type"
                                    fullWidth
                                    size="small"
                                    {...register("jt_unit_type")}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_city') }}
                                    label="City"
                                    fullWidth
                                    size="small"
                                    {...register("jt_city", { required: true })}
                                    error={Boolean(errors?.jt_city)}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" error={Boolean(errors?.jt_province)}>
                                    <InputLabel id="select-jt-province">Province</InputLabel>
                                    <Controller
                                        name="jt_province"
                                        control={control}
                                        rules={{ required: true }} // Validation
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="select-jt-province"
                                                label="Province"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                {provinceList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="select-jt-country">Country</InputLabel>
                                    <Controller
                                        name="jt_country"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="select-jt-country"
                                                label="Country"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                {countryList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField InputLabelProps={{ shrink: checkShrink('jt_postal_code') }}
                                    label="Postal Code"
                                    fullWidth
                                    size="small"
                                    id="jt-postal-code"
                                    {...register("jt_postal_code")}

                                />
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={6}></Grid> */}

                        {/*----------- eo address ------------*/}



                        {/* ---------------joint account employment status ------------ */}
                        {/*  <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-employment-status" className='font15px'>Employment Status</label>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors.jt_employment_status)}>
                                <InputLabel id="jt-employment-status-label">Employment Status </InputLabel>
                                <Select
                                    labelId="jt-employment-status-label"
                                    id="jt-employment-status"
                                    label="Employment Status"
                                    name='jt_employment_status'
                                    
                                    classes={{ select: "custom-select-label" }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                        PaperProps: { sx: { maxHeight: 200 } }
                                    }}
                                    inputProps={{
                                        ...register('jt_employment_status', {
                                            require: true,
                                            onChange: (e) => changePersonalInfo(e),
                                        })
                                    }}
                                >
                                    {employmentDataArray.map((row) => {
                                        return (
                                            <MenuItem value={row.value}>{row.label}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}></Grid> */}

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-emp-name" className='font15px'>Name Of Employer</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_emp_name') }}
                                label="Name Of Employer"
                                fullWidth
                                id='jt-emp-name'
                                size='small'
                                {...register("jt_emp_name", { required: true })}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>


                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-emp-business" className='font15px'>Type of Business</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_emp_business') }}
                                label="Type of Business"
                                fullWidth
                                id='jt-emp-business'
                                size='small'
                                {...register("jt_emp_business", { required: true })}
                                error={Boolean(errors?.jt_emp_business)}
                            />
                        </Grid>
                        <Grid item xs={3}></Grid>

                        <Grid item xs={3} className='text-right align-content-center'>
                            <label htmlFor="jt-occupation" className='font15px'>Occupation</label>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField InputLabelProps={{ shrink: checkShrink('jt_occupation') }}
                                label="Occupation"
                                fullWidth
                                id='jt-occupation'
                                size='small'
                                {...register("jt_occupation")}

                            />
                        </Grid>
                        <Grid item xs={3}></Grid>


                        {/* ================================== Joint Account Spousal Information ========================================== */}

                        {jointMaritalStatus == 2 || jointMaritalStatus == 3 ?

                            <>
                                <Grid item xs={12}>
                                    <Typography component={'h3'} className='form-head-gray-title' sx={{
                                        backgroundColor: "transparent",
                                        fontWeight: 600
                                    }}>Joint Account: Spousal Information</Typography>
                                </Grid>

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt_spousal_first_name" className='font15px'>First Name</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_first_name') }}
                                        label="First Name"
                                        fullWidth
                                        size='small'
                                        {...register("jt_s_first_name")}

                                    />

                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt-s-middle-initial" className='font15px'>Middle Initial</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_middle_name') }}
                                        label="Middle Initial"
                                        id='jt-s-middle-initial'
                                        fullWidth
                                        size='small'
                                        {...register("jt_s_middle_name")}

                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt-s-last-name" className='font15px'>Last Name</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_last_name') }}
                                        label="Last Name"
                                        fullWidth
                                        id='jt-s-last-name'
                                        size='small'
                                        {...register("jt_s_last_name")}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>


                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt-s-emp-name" className='font15px'>Name Of Employer</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_emp_name') }}
                                        label="Name Of Employer"
                                        fullWidth
                                        id='jt-s-emp-name'
                                        size='small'
                                        {...register("jt_s_emp_name")}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>


                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt-s-emp-business" className='font15px'>Type of Business</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_emp_business') }}
                                        label="Type of Business"
                                        fullWidth
                                        id='jt-s-emp-business'
                                        size='small'
                                        {...register("jt_s_emp_business")}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>

                                <Grid item xs={3} className='text-right align-content-center'>
                                    <label htmlFor="jt-s-occupation" className='font15px'>Occupation</label>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: checkShrink('jt_s_occupation') }}
                                        label="Occupation"
                                        fullWidth
                                        id='jt-s-occupation'
                                        size='small'
                                        {...register("jt_s_occupation")}
                                    />
                                </Grid>
                                <Grid item xs={3}></Grid>
                            </>
                            :
                            null
                        }
                    </Grid>
                    : null
                }

                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>

            </form>
            {loader}
            <ToastContainer />
        </>
    )
}

export default PersonalInformation